/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */


import { AccessType, MetricGroup } from '../types/metricGroup';

export const getGroupLabel = (group: MetricGroup) => {
  if (group.accessType === AccessType.Inherited) {
    return `Inherited: ${group.groupName}`;
  }

  if (group.accessType === AccessType.Assigned && group.initiative) {
    return `${group.initiative.name} - ${group.groupName}`
  }

  return group.groupName;
}
